import React from 'react';
import { Animated } from 'react-animated-css';
import './About.scss';

export const About = () => {
  return (<div className="container about">
    <Animated animationIn="fadeInDown" animationOut="slideOutLeft" animationInDuration={500} animationInDelay={50} animationOutDuration={300} isVisible={true}>
      <div className="row">
        <div className="col-6 contacts">
          <div id="contact-details">
            <h3>Our Hive Accounts:</h3>
            <ul>
              <li><b>BLOG</b> <a href="https://peakd.com/@cryptoshots.nft" target="_blank" rel="noreferrer">peakd.com/@cryptoshots.nft</a></li>
              <li>Community <a href="https://peakd.com/c/hive-190697/created" target="_blank" rel="noreferrer">peakd.com/c/hive-190697</a></li>
              <li>Marketing <a href="https://peakd.com/@cryptoshots.play" target="_blank" rel="noreferrer">peakd.com/@cryptoshots.play</a></li>
            </ul><br/>

            <h3>Other socials:</h3>
            <ul>
              <li>Twitter <a href="https://twitter.com/cryptoshots_nft" target="_blank" rel="noreferrer">twitter.com/cryptoshots_nft</a></li>
              <li>Discord <a href="https://crypto-shots.com/discord" target="_blank" rel="noreferrer">crypto-shots.com/discord</a></li>
            </ul>
          </div>
        </div>
        <div className="col-1"></div>
      </div>
    </Animated>
  </div>);
};
